(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsListenerWashBoxViewModel', FacilityDetailsListenerWashBoxViewModelFactory);

  /** @ngInject */
  function FacilityDetailsListenerWashBoxViewModelFactory() {
    function FacilityDetailsListenerWashBoxViewModel(listenerJson) {

      if (typeof listenerJson !== 'undefined') {
        this.refresh(listenerJson);
      }
    }

    FacilityDetailsListenerWashBoxViewModel.prototype.destroy = function () {

    };

    FacilityDetailsListenerWashBoxViewModel.prototype.refresh = function (listenerJson) {
      this.pointId = listenerJson.id;
      this.name = listenerJson.name;
      this.listenerStatus = 'offline';
      this.hhanleDeviceStatus = "0";
      var that = this;
      listenerJson.feeds.forEach(function(status) {
            if (status.reference === "CONNECTION_ERROR" && status.currentValue === "0") {
                that.listenerStatus = 'online';
            }
      });
      listenerJson.actuators.forEach(function(status) {
        if (status.reference === 'OP_BUTTON') {
          that.hhanleDeviceStatus = status.value;
        }
      });
    };

    FacilityDetailsListenerWashBoxViewModel.prototype.refreshFeed = function () {

    };

    return FacilityDetailsListenerWashBoxViewModel;

  }
})();
